import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import ViewTariffTable from "./ViewTariffPlansTable";
const ViewTariffPlans = () => {
  return (
    <GlobalContext.Consumer>
      {(context) => (
        <div style={{ padding: "1rem" }} className="bg-light">
          <div style={{ borderRadius: "8px" }} className="card m-0 p-0 mt-4 mr-2 ml-2">
            <div className="card-body m-0 p-1 px-2">
              <div>
               <ViewTariffTable />
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default ViewTariffPlans;
